import { Component, forwardRef, Attribute, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { QuillModules } from 'ngx-quill';

import Quill from 'quill';

const link = Quill.import('formats/link');
const font = Quill.import('formats/font');

@Component({
  selector: 'app-text-editor',
  templateUrl: './text-editor.component.html',
  styleUrls: ['./text-editor.component.scss'],
  providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TextEditorComponent), multi: true }],
})
export class TextEditorComponent implements ControlValueAccessor {
  @Input() public placeholder: string = '';
  @Input() public readonly: boolean = false;
  @Input() public tabIndex: number;
  @Input() public sanitize: boolean = false;

  public get disabled(): boolean {
    return this.isDisabled;
  }

  public editorModules: QuillModules = {
    imageResize: true,
  };

  public content: any = null;
  private isDisabled: boolean;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(@Attribute('class') public classes: string) {}

  public writeValue(value: any): void {
    if (this.content !== value) {
      this.content = value;
      this.onChange(value);
    }
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  public onContentChanged(event: any): void {
    this.onChange(event.html);
  }
}
